/**
 * @function to create Retail Session to all apis
 * @param var countryCode  languageCode and Digital sessionID
 * @returns  api url & payload the currencies
 */

const createRetailSessionPayload = (countryCode, languageCode, host, sessionID) => {
    const createSessionurl = `https://${host}/wudgtsrvs-retail/mobiliser/rest/channel/GwpCreateSession`;
    try {
        const reqPayload = {
            channel: {
                device_identifier: 'RESPONSIVE_WEB',
                is_responsive: 'true',
                name: 'MOB',
                type: 'RETAIL_MOBILE',
                version: '9D01'
            },
            device: {
                id: '',
                type: 'MOBILE'
            },
            external_reference_no: '1',
            locale: {
                'country_code': countryCode,
                'language_code': languageCode
            },
            security: {
                "digital": {
                    "sessionid": sessionID
                }
            }
        };

        return {
            createSessionurl,
            reqPayload
        }

    } catch (e) {
        console.warn('Error in create retail session service', e)
    }

}

const createRetailSessionMethod = (country_iso_code, lang_code, host, sessionID) => {
    const { createSessionurl, reqPayload } = createRetailSessionPayload(country_iso_code, lang_code, host, sessionID);
    return httpRequest.post(createSessionurl, reqPayload, { "Content-type": "application/json" });
}